export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/girl_icon.3467bfe7.svg","height":17,"width":19,"blurWidth":0,"blurHeight":0};